<ng-container *ngIf="sharedDataState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.transfer-cost-center-cost-unit.header" | translate }}
    </h1>
    <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
    <div mat-dialog-content>

        <div class="info-text">
            <mat-icon>info</mat-icon>
            <p>{{ "app.dialog.transfer-cost-center-cost-unit.info.label" | translate }}
            </p>
        </div>

        <mat-divider></mat-divider>

        <div class="selection-container" [formGroup]="formGroup">
            <mat-form-field appearance="fill">
                <mat-label>{{ "app.dialog.transfer-cost-center-cost-unit.costAccountingType.label" | translate }}</mat-label>
                <mat-select formControlName="costAccountingTypeId">
                    <ng-container *ngFor="let costAccountingType of state.costAccountingTypeLookup | keyvalue">
                        <mat-option [value]="costAccountingType.key">
                            {{costAccountingType.value.name}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ "app.dialog.transfer-cost-center-cost-unit.targetCostAccountingType.label" | translate }}</mat-label>
                <mat-select formControlName="targetCostAccountingTypeId">
                    <ng-container *ngFor="let costAccountingType of state.costAccountingTypeLookup | keyvalue">
                        <mat-option [value]="costAccountingType.key">
                            {{costAccountingType.value.name}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!formGroup.valid" mat-flat-button color="primary" (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
